/** Supported storefront currencies (ISO 4217). */
export const SHOP_CURRENCY_OPTIONS = [
  { value: 'RON', label: 'RON — Leu românesc' },
  { value: 'EUR', label: 'EUR — Euro' },
  { value: 'USD', label: 'USD — Dolar american' },
  { value: 'GBP', label: 'GBP — Liră sterlină' },
  { value: 'MDL', label: 'MDL — Leu moldovenesc' },
] as const

export type ShopCurrencyCode = (typeof SHOP_CURRENCY_OPTIONS)[number]['value']

const SHORT_LABELS: Record<string, string> = {
  RON: 'Lei',
  EUR: '€',
  USD: '$',
  GBP: '£',
  MDL: 'MDL',
}

export function normalizeShopCurrency(raw?: string | null): string {
  const code = (raw || 'RON').trim().toUpperCase()
  return /^[A-Z]{3}$/.test(code) ? code : 'RON'
}

export function shopCurrencyLabel(raw?: string | null): string {
  const code = normalizeShopCurrency(raw)
  return SHORT_LABELS[code] || code
}
